/**
 * Traducciones de prompts para la IA (inglés y español)
 */

export const promptTranslations = {
  es: {
    contentType: {
      movie: 'películas',
      series: 'series',
      music: 'música'
    },
    criticalSection: {
      withExisting: (count, contentLabel, countNew) => 
        `⚠️⚠️⚠️ ATENCIÓN CRÍTICA ⚠️⚠️⚠️
El usuario ya tiene ${count} ${contentLabel} recomendadas. DEBES generar ${countNew} ${contentLabel} COMPLETAMENTE NUEVAS que NO estén en la lista "RECOMENDACIONES EXISTENTES".
ANTES de recomendar cada ${contentLabel}, verifica que NO esté en esa lista comparando el título EXACTO.`,
      noExisting: (count, contentLabel) =>
        `⚠️⚠️⚠️ ATENCIÓN ⚠️⚠️⚠️
El usuario aún NO tiene recomendaciones de ${contentLabel}. Genera exactamente ${count} recomendaciones NUEVAS, reales y variadas. No hay lista previa que evitar.`
    },
    watchedBlock: {
      label: 'CONTENIDO YA VISTO (NO RECOMENDAR)',
      none: 'Ninguno aún.'
    },
    existingRecommendations: {
      title: 'RECOMENDACIONES EXISTENTES',
      warning: 'NO REPETIR ESTAS',
      critical: 'CRÍTICO: Compara CADA título que vayas a recomendar con la lista de títulos arriba. Si coincide, NO lo recomiendes.'
    },
    liked: {
      label: 'QUE LE GUSTARON',
      none: 'Ninguno aún.'
    },
    disliked: {
      label: 'QUE NO LE GUSTARON',
      avoid: 'evitar algo muy similar'
    },
    favorites: {
      actors: 'ACTORES FAVORITOS',
      artists: 'ARTISTAS FAVORITOS',
      none: 'No especificados'
    },
    rules: {
      title: 'REGLAS CRÍTICAS (LEE CON MUCHA ATENCIÓN)',
      rule1: (contentLabel, music) => 
        `1. SOLO ${contentLabel} que realmente existen - NO inventes títulos${music ? ', artistas o bandas' : ', directores o actores'}`,
      rule2: '2. NO recomiendes contenido ya visto (lista "CONTENIDO YA VISTO")',
      rule3: (contentLabel, count) =>
        `3. 🚫 PROHIBIDO REPETIR: La lista "RECOMENDACIONES EXISTENTES" contiene ${count} ${contentLabel} que YA están recomendadas.
   - ANTES de recomendar cualquier ${contentLabel}, compara su TÍTULO EXACTO con CADA uno de la lista "RECOMENDACIONES EXISTENTES"
   - Si el título coincide (ignorando mayúsculas/minúsculas), NO lo recomiendes
   - Si el título es similar (>80% similitud), NO lo recomiendes
   - EJEMPLO: Si "RECOMENDACIONES EXISTENTES" tiene "Inception (2010)", NO recomiendes "Inception" ni "Inception (2010)"`,
      rule4: '4. NO repitas de "QUE LE GUSTARON" ni de "CONTENIDO YA VISTO" - esas ya están en el historial',
      rule5: (contentLabel) => `5. IMPORTANTE: Varía completamente. Busca ${contentLabel} NUEVAS y DIFERENTES que NO estén en NINGUNA lista anterior`,
      rule6: (contentLabel) => `6. Basa las recomendaciones en el contenido mejor calificado pero busca ${contentLabel} NUEVAS`,
      rule7: (contentLabel) => `7. Evita ${contentLabel} muy similares a las que no le gustaron`,
      rule8: (contentType) => `8. Considera los ${contentType === 'music' ? 'artistas' : 'actores'} favoritos`,
      rule9: '9. Responde ÚNICAMENTE con JSON válido',
      rule10: (count) =>
        `10. 🚫 UNICIDAD EN EL JSON: El array "recommendations" debe tener exactamente ${count} títulos DISTINTOS. Nunca repitas el mismo título dos veces en la misma respuesta (ni variaciones del mismo film/serie/canción).`,
      remember: (contentLabel) => `RECUERDA: Si generas una ${contentLabel} que ya está en "RECOMENDACIONES EXISTENTES", tu respuesta será incorrecta.`
    },
    jsonExample: {
      music: {
        title: 'Título de canción REAL',
        artist: 'Artista o banda REAL'
      },
      movie: {
        title: 'Título REAL',
        director: 'Director REAL',
        actors: ['Actor REAL 1', 'Actor REAL 2']
      }
    },
    dateReference: (dateStr, year) =>
      `FECHA ACTUAL DE REFERENCIA: ${dateStr} (Año ${year}). Solo recomienda contenido que ya fue estrenado/publicado antes de esta fecha. Puedes recomendar contenido hasta ${year} si ya fue estrenado.`,
    crossContent: (contentLabel, block) =>
      `\nEl usuario pide sus PRIMERAS recomendaciones de ${contentLabel} (puede no tener historial en este tipo aún). Para orientarte, sus gustos en otros contenidos: ${block}. Genera recomendaciones que encajen con estos gustos.\n`,
    recentlyRated: (line) =>
      `\nCONTENIDO RECIÉN VALORADO (tener en cuenta para esta petición): ${line}. Si le gustó (nota alta), sugiere algo similar; si no le gustó (nota baja), evita algo muy similar.\n`,
    retrievedContext: (block) =>
      `\nCONTENIDO MÁS RELEVANTE PARA ESTA PETICIÓN (similitud):\n${block}\n`
  },
  en: {
    contentType: {
      movie: 'movies',
      series: 'TV series',
      music: 'music'
    },
    criticalSection: {
      withExisting: (count, contentLabel, countNew) =>
        `⚠️⚠️⚠️ CRITICAL ATTENTION ⚠️⚠️⚠️
The user already has ${count} ${contentLabel} recommended. YOU MUST generate ${countNew} COMPLETELY NEW ${contentLabel} that are NOT in the "EXISTING RECOMMENDATIONS" list.
BEFORE recommending each ${contentLabel}, verify that it is NOT in that list by comparing the EXACT title.`,
      noExisting: (count, contentLabel) =>
        `⚠️⚠️⚠️ ATTENTION ⚠️⚠️⚠️
The user does NOT yet have ${contentLabel} recommendations. Generate exactly ${count} NEW, real and varied recommendations. There is no previous list to avoid.`
    },
    watchedBlock: {
      label: 'ALREADY WATCHED CONTENT (DO NOT RECOMMEND)',
      none: 'None yet.'
    },
    existingRecommendations: {
      title: 'EXISTING RECOMMENDATIONS',
      warning: 'DO NOT REPEAT THESE',
      critical: 'CRITICAL: Compare EACH title you are going to recommend with the title list above. If it matches, DO NOT recommend it.'
    },
    liked: {
      label: 'THAT THEY LIKED',
      none: 'None yet.'
    },
    disliked: {
      label: 'THAT THEY DID NOT LIKE',
      avoid: 'avoid something very similar'
    },
    favorites: {
      actors: 'FAVORITE ACTORS',
      artists: 'FAVORITE ARTISTS',
      none: 'Not specified'
    },
    rules: {
      title: 'CRITICAL RULES (READ CAREFULLY)',
      rule1: (contentLabel, music) =>
        `1. ONLY ${contentLabel} that really exist - DO NOT invent titles${music ? ', artists or bands' : ', directors or actors'}`,
      rule2: '2. DO NOT recommend already watched content (list "ALREADY WATCHED CONTENT")',
      rule3: (contentLabel, count) =>
        `3. 🚫 FORBIDDEN TO REPEAT: The "EXISTING RECOMMENDATIONS" list contains ${count} ${contentLabel} that are ALREADY recommended.
   - BEFORE recommending any ${contentLabel}, compare its EXACT TITLE with EACH one in the "EXISTING RECOMMENDATIONS" list
   - If the title matches (ignoring case), DO NOT recommend it
   - If the title is similar (>80% similarity), DO NOT recommend it
   - EXAMPLE: If "EXISTING RECOMMENDATIONS" has "Inception (2010)", DO NOT recommend "Inception" or "Inception (2010)"`,
      rule4: '4. DO NOT repeat from "THAT THEY LIKED" or "ALREADY WATCHED CONTENT" - those are already in history',
      rule5: (contentLabel) => `5. IMPORTANT: Vary completely. Look for NEW and DIFFERENT ${contentLabel} that are NOT in ANY previous list`,
      rule6: (contentLabel) => `6. Base recommendations on the best-rated content but look for NEW ${contentLabel}`,
      rule7: (contentLabel) => `7. Avoid ${contentLabel} very similar to those they did not like`,
      rule8: (contentType) => `8. Consider favorite ${contentType === 'music' ? 'artists' : 'actors'}`,
      rule9: '9. Respond ONLY with valid JSON',
      rule10: (count) =>
        `10. 🚫 UNIQUE JSON ARRAY: The "recommendations" array must contain exactly ${count} DISTINCT titles. Never repeat the same title twice in one response (no duplicate movie/series/song entries).`,
      remember: (contentLabel) => `REMEMBER: If you generate a ${contentLabel} that is already in "EXISTING RECOMMENDATIONS", your response will be incorrect.`
    },
    jsonExample: {
      music: {
        title: 'REAL song title',
        artist: 'REAL artist or band'
      },
      movie: {
        title: 'REAL Title',
        director: 'REAL Director',
        actors: ['REAL Actor 1', 'REAL Actor 2']
      }
    },
    dateReference: (dateStr, year) =>
      `CURRENT REFERENCE DATE: ${dateStr} (Year ${year}). Only recommend content that was already released/published before this date. You can recommend content up to ${year} if it was already released.`,
    crossContent: (contentLabel, block) =>
      `\nThe user is asking for their FIRST recommendations of ${contentLabel} (may not have history in this type yet). To guide you, their tastes in other content: ${block}. Generate recommendations that fit these tastes.\n`,
    recentlyRated: (line) =>
      `\nRECENTLY RATED CONTENT (take into account for this request): ${line}. If they liked it (high rating), suggest something similar; if they didn't like it (low rating), avoid something very similar.\n`,
    retrievedContext: (block) =>
      `\nMOST RELEVANT CONTENT FOR THIS REQUEST (similarity):\n${block}\n`
  }
};
